import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    padding: theme.spacing(0, 0.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  emptyState: {
    marginTop: theme.spacing(4),
  },
  trainingsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  trainingsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  chartsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
  },
  chartSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  chartContainer: {
    ...theme.mixins.appContainer,
    width: '100%',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
}));
